import Client from './Client'

export interface IRenameRequest {
  newPath: string
}

export interface IFileInfo {
  isDir: boolean
  path: string
}

export interface IFolderInfo {
  path: string
  filesInfo: IFileInfo[]
}

const API_PREFIX = '/sc/fs/api/v2'

/**
 * Класс для работы с апи v1.0.1
 */
export default class FS {
  constructor(public readonly client: Client) {}

  /*
    Folder API
   */

  // Прочесть содержимое папки
  // -
  // Коды ошибок:
  // unauthorized
  // forbidden
  // operation_not_allowed
  // not_found
  folderRead(path: string): Promise<IFolderInfo> {
    return this.client.app
      .createAuthorizedRequest(`${API_PREFIX}/folders/${path}`)
      .execute()
  }

  // Создать папку
  // -
  // Коды ошибок:
  // unauthorized
  // forbidden
  // operation_not_allowed
  // folder_exists
  folderCreate(path: string): Promise<void> {
    return this.client.app
      .createAuthorizedRequest(`${API_PREFIX}/folders`)
      .postJson({ path })
      .execute()
  }

  // переименовать папку
  // -
  // Коды ошибок:
  // unauthorized
  // forbidden
  // operation_not_allowed
  // folder_not_found
  // folder_exists
  folderRename(path: string, payload: IRenameRequest): Promise<void> {
    return this.client.app
      .createAuthorizedRequest(`${API_PREFIX}/folders/${path}`)
      .postJson(payload)
      .execute()
  }

  // Удалить папку
  // -
  // Коды ошибок:
  // unauthorized
  // forbidden
  // operation_not_allowed
  // folder_not_found
  // folder_not_empty
  folderDelete(path: string): Promise<void> {
    return this.client.app
      .createAuthorizedRequest(`${API_PREFIX}/folders/${path}`)
      .delete()
      .execute()
  }

  /*
    File API
   */

  // Прочесть содержимое файла
  // -
  // Коды ошибок:
  // unauthorized
  // forbidden
  // operation_not_allowed
  // not_found
  fileDownload(path: string): Promise<Blob> {
    return this.client.app
      .createAuthorizedRequest(`${API_PREFIX}/files/${path}`)
      .setResponseType('blob')
      .execute()
  }

  // Загрузить фаил
  // -
  // Коды ошибок:
  // unauthorized
  // forbidden
  // operation_not_allowed
  fileUpload(path: string, payload: Blob): Promise<void> {
    return this.client.app
      .createAuthorizedRequest(`${API_PREFIX}/files/${path}`)
      .post(payload)
      .execute()
  }

  // Переименовать фаил
  // -
  // Коды ошибок:
  // unauthorized
  // forbidden
  // operation_not_allowed
  // folder_not_found
  // file_exists
  fileRename(path: string, payload: IRenameRequest): Promise<void> {
    return this.client.app
      .createAuthorizedRequest(`${API_PREFIX}/files/${path}`)
      .postJson(payload)
      .execute()
  }

  // Удалить файл
  // -
  // Коды ошибок:
  // unauthorized
  // forbidden
  // operation_not_allowed
  // not_found
  fileDelete(path: string): Promise<void> {
    return this.client.app
      .createAuthorizedRequest(`${API_PREFIX}/files/${path}`)
      .delete()
      .execute()
  }
}
